import { Helmet } from 'react-helmet-async';

import TagSearchView from 'src/sections/tag-search/view/tag-search-view';

export default function TagSearchPage() {
  return (
    <>
      <Helmet>
        <title> Tag Search | Aisy </title>
      </Helmet>

      <TagSearchView />
    </>
  );
} 